import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Alerta } from '../../_models/alerta';
import { AlertaService } from '../../_services/alerta.service';

@Component( {
  selector: 'app-alerta-listado',
  templateUrl: 'alerta-listado.component.html'
} )

export class AlertaListadoComponent implements OnInit {

  lisAlertas: Alerta[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  descripcion: string;
  mosDescripcion = false;

  constructor( private aleServicio: AlertaService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/alertas' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'ALERTAS.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'ALERTAS.LBL_NOMBRE' ), sort: false },
      { field: 'descripcionCorta', header: this.navServicio.buscarMensaje( 'ALERTAS.LBL_DESCRIPCION' ), sort: false },
      { field: 'tipoCondicion', header: this.navServicio.buscarMensaje( 'ALERTAS.LBL_TIPOCONDICION' ), sort: false },
      { field: 'indicadorAlertaInterna', header: this.navServicio.buscarMensaje( 'ALERTAS.LBL_ALERTAINTERNA' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'alerta.component' );

    this.aleServicio.listado().subscribe( registros => {
      registros.map( ( s: Alerta ) => {
        if ( s.descripcion.length > 100 ) {
          s.descripcionCorta = s.descripcion.substring( 0, 100 );
          s.mostrarDescripcion = true;
        } else {
          s.descripcionCorta = s.descripcion;
        }
        s.tipoCondicion = s.estadoAlertaDescartes ? this.navServicio.buscarMensaje( 'ALERTAS.LBL_DESCARTA' ): this.navServicio.buscarMensaje( 'ALERTAS.LBL_ALERTA' );
        this.lisAlertas.push( s );
      } );
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/alertas/agregar' ] );
  }

  editar( registro: Alerta ) {
    this.router.navigate( [ 'apl/alertas/actualizar/' + registro.idAlerta ] )
  }

  ver( registro: Alerta ) {
    this.router.navigate( [ 'apl/alertas/detalle/' + registro.idAlerta ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'alerta.component', this.busqueda );
  }

  mostrarDescripcion( registro: Alerta ) {
    this.descripcion = registro.descripcion;
    this.mosDescripcion = true;
  }

  cerrarDescripcion(){
    this.mosDescripcion = false;
  }
}
